module.exports = __webpack_public_path__ + "static/media/S.a9ff8c01.jpg";